export default defineNuxtRouteMiddleware((to, from) => {
	// isAuthenticated() is an example method verifying if a user is authenticated
	if (process.env.NODE_ENV === "production") {
		if (to.fullPath.includes("swagger-ui")) {
			return abortNavigation();
		}
	}
});
